import getTemplates from './getTemplates';
import downloadTemplate from './downloadTemplate';
import uploadTemplate from './uploadTemplate';
import getBulkUploads from './getBulkUploads';
import getBulkUpload from './getBulkUpload';
import getParameterItems from './getParameterItems';
import createBulkUpload from './createBulkUpload';
import downloadBulkExcel from './downloadBulkExcel';

export {
  getTemplates,
  downloadTemplate,
  uploadTemplate,
  getBulkUploads,
  getBulkUpload,
  getParameterItems,
  createBulkUpload,
  downloadBulkExcel,
};



// WEBPACK FOOTER //
// ./src/services/api/linkUpload/index.ts